import styled from 'styled-components';

import { basicSmallTextStyle, IconWrapper } from '@dreryk/react-components';

export const StyledTooltipInfoBlockDate = styled.span`
   ${basicSmallTextStyle};
   color: ${({ theme }) => theme.borderDark};

   &:first-letter {
      text-transform: capitalize;
   }
`;
StyledTooltipInfoBlockDate.displayName = 'StyledTooltipInfoBlockDate';

export const StyledTooltipInfoBlockLabel = styled.span`
   color: ${({ theme }) => theme.borderDark};
`;
StyledTooltipInfoBlockLabel.displayName = 'StyledTooltipInfoBlockLabel';

type StyledTooltipInfoBlockIconWrapperProps = {
   $positive: boolean;
};

export const StyledTooltipInfoBlockIconWrapper = styled(IconWrapper)<StyledTooltipInfoBlockIconWrapperProps>`
   transform: ${({ $positive }) => ($positive ? 'rotate(90deg)' : 'rotate(270deg)')};
`;
StyledTooltipInfoBlockIconWrapper.displayName = 'StyledTooltipInfoBlockIconWrapper';
